import { Component, OnInit, inject } from '@angular/core';
import { PagesService } from '../pages.service';
import { MenuItem } from '../producers/interfaces';
import { Router, RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-faq',
    imports: [RouterOutlet],
    templateUrl: './faq.component.html',
    styleUrl: './faq.component.scss'
})
export class FaqComponent implements OnInit {
  pagesService = inject(PagesService);

  ngOnInit(): void {
    this.setUpMenu();
  }

  private setUpMenu() {
    const menu: MenuItem[] = [
      {
        link: 'faq/prospective-members',
        title: 'Prospective members',
        active: true
      },
      {
        link: 'faq/members',
        title: 'Members',
        active: false
      },
      {
        link: 'faq/prospective-producers',
        title: 'Prospective Businesses and Producers',
        active: true
      }
    ];

    this.pagesService.setSideMenu(menu);
  }
}
